import { render, staticRenderFns } from "./ContentsListBasicSkChemical.vue?vue&type=template&id=09aaa8da"
import script from "./ContentsListBasicSkChemical.vue?vue&type=script&lang=js"
export * from "./ContentsListBasicSkChemical.vue?vue&type=script&lang=js"
import style0 from "./ContentsListBasicSkChemical.vue?vue&type=style&index=0&id=09aaa8da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports